import {
    CREATE_DIAGNOSTIC_DEVICE_OPEN_MODAL,
    CREATE_DIAGNOSTIC_DEVICE_CLOSE_MODAL,
    CREATE_DIAGNOSTIC_DEVICE_GET_DEVICE_REQUEST,
    CREATE_DIAGNOSTIC_DEVICE_GET_DEVICE_RESULT,
    CREATE_DIAGNOSTIC_DEVICE_REQUEST,
    CREATE_DIAGNOSTIC_DEVICE_RESULT,
    CREATE_DIAGNOSTIC_DEVICE_SET_DEVICES,
    CREATE_DIAGNOSTIC_DEVICE_SEARCH_DEVICE_MODEL_REQUEST,
    CREATE_DIAGNOSTIC_DEVICE_SEARCH_DEVICE_MODEL_RESULT,
    CREATE_DIAGNOSTIC_DEVICE_SEARCH_COMMANDS_REQUEST,
    CREATE_DIAGNOSTIC_DEVICE_SEARCH_COMMANDS_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    device: null,
    devices: [],
    deviceModels: null,
    commands: []
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case CREATE_DIAGNOSTIC_DEVICE_SEARCH_COMMANDS_REQUEST:
            return { ...state, loading: true }

        case CREATE_DIAGNOSTIC_DEVICE_SEARCH_COMMANDS_RESULT:
            return { ...state, loading: false, commands: action.payload }

        case CREATE_DIAGNOSTIC_DEVICE_SEARCH_DEVICE_MODEL_REQUEST:
            return { ...state, loading: true }

        case CREATE_DIAGNOSTIC_DEVICE_SEARCH_DEVICE_MODEL_RESULT:
            return { ...state, loading: false, deviceModels: action.payload }

        case CREATE_DIAGNOSTIC_DEVICE_SET_DEVICES:
            return { ...state, devices: action.payload || [] }

        case CREATE_DIAGNOSTIC_DEVICE_OPEN_MODAL:
            return { ...state, openModal: true, devices: action.payload || [] }

        case CREATE_DIAGNOSTIC_DEVICE_CLOSE_MODAL:
            return { ...state, openModal: false }

        case CREATE_DIAGNOSTIC_DEVICE_GET_DEVICE_REQUEST:
            return { ...state, loading: true }

        case CREATE_DIAGNOSTIC_DEVICE_GET_DEVICE_RESULT:
            return { ...state, loading: false, device: action.payload }

        case CREATE_DIAGNOSTIC_DEVICE_REQUEST:
            return { ...state, loading: true }

        case CREATE_DIAGNOSTIC_DEVICE_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "CREATE_DIAGNOSTIC_DEVICE"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};